export const PaymentsWalletStatusEnum = {
  Active: "ACTIVE",
  Pending: "Pending",
  Inactive: "INACTIVE",
  Suspended: "SUSPENDED",
};

export const PaymentTransactionStatusEnum = {
  Pending: "pending",
  Approved: "approved",
  Declined: "declined",
  Error: "error",
};

export const PaymentTransactionTypeEnum = {
  Withdrawal: "withdrawal",
  Deposit: "deposit",
  Transfer: "transfer",
};

export const PaymentCardPaymentStatusEnum = {
  Success: "C",
};

export const PaymentCurrencyEnum = {
  KES: "KES",
  USD: "USD",
  CNT: "CNT",
};

export const PaymentExchangeRateTypeEnum = {
  DEPOSIT: "DEPOSIT",
  WITHDRAWAL: "WITHDRAWAL",
};
